import { AxiosError } from "axios";
import { createContext } from "react";

import { VacancyType } from "@/types/vacancy/VacancyType";

export type VacancyDetailContextType = {
    vacancy: VacancyType | undefined
    vacancyFetching: boolean
    vacancyLoading: boolean
    vacancyError: AxiosError | null
}

export const VacancyDetailContext = createContext<VacancyDetailContextType | undefined>(undefined);
